import isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';

import { useGetProcessTaskTemplate } from 'src/hooks/process-task-templates/get-process-task-template.hook';
import { useUpdateProcessTasksTemplate } from 'src/hooks/process-task-templates/update-task-templates.hook';

import { ProcessTemplateForm } from '../process-template-form';
import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

import {
  IProcessesTemplateItem,
  IProcessTemplateItemTask,
} from '../../../process-templates-table/process-templates-table.interfaces';

const EditProcessTemplate = ({ id }: { id: string }) => {
  const navigate = useNavigate();

  const { processTaskTemplate, loading } = useGetProcessTaskTemplate(id);

  const { updateProcessTasksTemplate } = useUpdateProcessTasksTemplate({
    onSuccess: () => navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.processTemplates}`),
  });

  const onFinishHandler = (
    values: IProcessesTemplateItem,
    taskList: IProcessTemplateItemTask[],
    taskIdsToDelete?: string[]
  ) => {
    const dataToUpdate: {
      _id: string;
      name: string;
      emailTemplateId: string;
      templateTasks?: IProcessTemplateItemTask[];
      taskIdsToDelete?: string[];
    } = {
      _id: processTaskTemplate._id,
      name: values.name,
      emailTemplateId: values.emailTemplateId,
      ...(!isEmpty(taskIdsToDelete) && { taskIdsToDelete }),
    };

    if (!isEmpty(taskList)) {
      dataToUpdate.templateTasks = taskList.map(
        ({ key, companyId, jobId, departmentId, responsiblePersonsIds, ...rest }) => {
          return {
            ...rest,
            ...(companyId && { companyId }),
            ...(responsiblePersonsIds && { responsiblePersonsIds }),
            ...(jobId && { jobId }),
            ...(departmentId && { departmentId }),
          };
        }
      );
    }

    return updateProcessTasksTemplate({
      variables: {
        payload: dataToUpdate,
      },
    });
  };

  const { templateTasks, ...rest } = processTaskTemplate;

  const tasks = !isEmpty(templateTasks)
    ? templateTasks.map((el: IProcessTemplateItemTask) => ({
        ...el,
        key: uuidv4(),
      }))
    : [];

  if (loading) {
    return <Loader />;
  }

  return (
    <ProcessTemplateForm onFinishHandler={onFinishHandler} processTemplate={rest} tasks={tasks} />
  );
};

export default EditProcessTemplate;
